import globals from'../globals.js';

import load_image from'../helpers/image-loader.js';
import load_video from'../helpers/video-loader.js';


var listPref = localStorage.getItem('directors_filter');
var filterToggles = document.querySelectorAll('.filter-toggle');
var directorsList = document.querySelector('.directors-list');
var floatingPreviews = document.querySelectorAll('.floating-preview');
var imgPreview = document.querySelectorAll('.ratio-film');

function directors_list(){
    
    listPref = localStorage.getItem('directors_filter');
    filterToggles = document.querySelectorAll('.filter-toggle');
    directorsList = document.querySelector('.directors-list');
    floatingPreviews = document.querySelectorAll('.floating-preview');
    imgPreview = document.querySelectorAll('.ratio-film');

    directorsList = document.querySelector('.directors-list');

    if(directorsList){
        bind_list_filters();
        update_list_class(); 
        bind_hover();
    }

};

function bind_hover(){

    for (let a = 0; a < floatingPreviews.length; a++) {
        let elm = floatingPreviews[a];

        elm.addEventListener('mouseenter', show_preivew);
        elm.addEventListener('mouseleave', hide_preview);
        
    }

    for (let a = 0; a < imgPreview.length; a++) {
        const element = imgPreview[a];
        element.classList.remove('visable');
    }

}

function hide_preview(e){

    for (let a = 0; a < floatingPreviews.length; a++) {
        floatingPreviews[a].style.opacity = 1;        
    }

    for (let a = 0; a < imgPreview.length; a++) {
        const element = imgPreview[a];
        element.classList.remove('visable');
        
    }

};

function show_preivew(e){

    let elm = e.target;
    let slug = elm.dataset.slug;

    for (let a = 0; a < floatingPreviews.length; a++) {
        floatingPreviews[a].style.opacity = 0.2;        
    }

    elm.style.opacity = 1;

    for (let a = 0; a < imgPreview.length; a++) {
        const element = imgPreview[a];
        element.classList.remove('visable');
    }

    let prev = document.querySelector(`.${slug}`);

    if(prev){
        prev.classList.add('visable');
    }

}

function update_filter_toggle(){
    let value = this.dataset.value;
    localStorage.setItem('directors_filter', value);
    listPref = value;
    update_list_class();
};

function bind_list_filters(){
    filterToggles = document.querySelectorAll('.filter-toggle');
   
    for (let a = 0; a < filterToggles.length; a++) {
        let elm = filterToggles[a];
        elm.addEventListener("click", update_filter_toggle);
    }
};

function unbind_list_filters(){
    filterToggles = document.querySelectorAll('.filter-toggle');
   
    for (let a = 0; a < filterToggles.length; a++) {
        let elm = filterToggles[a];
        elm.removeEventListener("click", update_filter_toggle);
    }
};

function update_list_class(){
    

    unbind_list_filters();

    if(!listPref){
        listPref = 'us';
        localStorage.setItem('directors_filter', 'us');
    }

    var active = document.querySelector(`[data-value*="${listPref}"]`);

    for (let a = 0; a < filterToggles.length; a++) {
        let elm = filterToggles[a];
        elm.classList.remove('active');
    }
    
    active.classList.add('active');

    floatingPreviews = document.querySelectorAll('.floating-preview');

    for (let a = 0; a < floatingPreviews.length; a++) {
        let elm = floatingPreviews[a];
        elm.classList.remove('visable');
    }

    setTimeout(function(){
        
        for (let a = 0; a < floatingPreviews.length; a++) {
            let elm = floatingPreviews[a];
            if(elm.classList.contains(`filter-${listPref}`)){
                elm.classList.add('filter-active');
            }else{
                elm.classList.remove('filter-active');
            }
        }

        let activeListItems = document.querySelectorAll('.filter-active');
        
        for (let a = 0; a < activeListItems.length; a++) {
        
            let elm = activeListItems[a];
            var rect = elm.getBoundingClientRect();
            elm.classList.remove('left','right');
    
            if(rect.left > window.innerWidth/2){
                elm.classList.add('right');
            }else{
                elm.classList.add('left');
            }
        }

        setTimeout(function(){

            for (let a = 0; a < activeListItems.length; a++) {
                let elm = activeListItems[a];
                elm.classList.add('visable');
            }

            bind_list_filters();
            
        }, 100);

    }, 200);

}


export default directors_list;